import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/seed-starting-calculator/SeedStartingCalculatorContent.tsx");
